import { Component, computed, ElementRef, HostListener, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { AvatarModule } from 'primeng/avatar';
import { NavigationService } from '../../services/navigation.service';
import { filter } from 'rxjs';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import * as WebshopActions from '../../store/webshop/webshop.actions';
import { selectSearchTerm } from '../../store/webshop/webshop.reducer';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [
    RouterModule,
    AvatarModule,
    FormsModule,
    InputTextModule,
    IconFieldModule,
    InputIconModule
  ],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss'
})
export class MenuComponent {
  private navigationService = inject(NavigationService);
  private router = inject(Router);
  private el = inject(ElementRef);
  private store = inject(Store);

  items = computed(() => this.navigationService.getMenuItems());
  selectedCountry = signal('NL');
  searchTerm = toSignal(this.store.select(selectSearchTerm), { initialValue: '' });
  searchExpanded = signal(false);

  languages = [
    {language: 'NL', label: 'Dutch'},
    {language: 'DE', label: 'Deutsch'},
    {language: 'GB', label: 'English'}
  ];

  constructor() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntilDestroyed()
    ).subscribe(() => {
      this.closeMenu();
    });
  }

  selectLanguage(lang: string) {
    this.selectedCountry.set(lang);
    this.closeMenu();
  }

  toggleSearch() {
    this.searchExpanded.update(v => !v);
    if (this.searchExpanded()) {
      setTimeout(() => {
        const input = this.el.nativeElement.querySelector('.search-input');
        input?.focus();
      }, 100);
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.searchExpanded() && !this.el.nativeElement.querySelector('.search-container')?.contains(event.target as Node)) {
      this.searchExpanded.set(false);
    }
  }

  updateSearchTerm(term: string) {
    this.store.dispatch(WebshopActions.setSearchTerm({ searchTerm: term }));
    if (term && this.router.url !== '/producten') {
       // Optioneel: navigeer naar producten pagina als er gezocht wordt?
       // De gebruiker vroeg hier niet specifiek om, maar het is wel gebruikelijk.
       // Voor nu houden we het simpel en doen we alleen de filtering als de gebruiker al op de pagina is.
    }
  }

  closeMenu() {
    const checkboxes = this.el.nativeElement.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((cb: HTMLInputElement) => cb.checked = false);
  }
}
